<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloDbUmbClasse } from '@/models/alodb/AloDbUmbClasse'

@Component({
  name: 'AdminUmbClasseList'
})

export default class AdminUmbClasseList extends AdminList<AloDbUmbClasse> {  
 
  get itemTypeName() {
    return "UmbClasse"
  }

}
</script>